/* eslint-disable no-undef */
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { STATUS } from "../constants";
const initialState = {
  body_style: [],
  transmission: [],
  fuel_type: [],
  warranty: [],
  disputeTitle: [],
  suppliertype: [],
  cancelReason: [],
  commissionRate: [],
  status: STATUS.LOADING,
  error: "",
  isUserDeleted: false,
};

export const adminSlice = createSlice({
  name: "admin",
  initialState: initialState,
  reducers: {
    bodyStyle: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        body_style: payload.bodyStyles,
      };
    },
    transmission: (state, action) => {
      const { payload } = action;
      // console.log(payload)
      return {
        ...state,
        transmission: payload.transmission,
      };
    },
    blockStatus: (state, action) => {
      state.blockStatus = action.payload;
    },
    fuel_type: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        fuel_type: payload.fuelType,
      };
    },
    disputeTitle: (state, action) => {
      const { payload } = action;
      // console.log(payload)
      return {
        ...state,
        disputeTitle: payload.titles,
      };
    },
    deleteUser: (state, action) => {
      state.isUserDeleted = true;
      const userId = action.payload;
      state.users = state.users.filter((user) => user.id !== userId);
    },
    warranty: (state, action) => {
      const { payload } = action;
      // console.log(payload)
      return {
        ...state,
        warranty: payload.warrantyDurations,
      };
    },
    suppliertype: (state, action) => {
      const { payload } = action;
      // console.log(payload)

      return {
        ...state,
        suppliertype: payload.supplierTypes,
      };
    },
    cancelReason: (state, action) => {
      const { payload } = action;
      // console.log(payload)
      return {
        ...state,
        cancelReason: payload.cancelReasons,
      };
    },
    commissionRate: (state, action) => {
      const { payload } = action;
      // console.log(payload)
      return {
        ...state,
        commissionRate: payload.commissionRate.rate,
      };
    },

    changeStatus: (state, action) => {
      return {
        ...state,
        status: action.payload,
      };
    },
    isError: (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    },
  },
});

export const {
  bodyStyle,
  transmission,
  fuel_type,
  warranty,
  disputeTitle,
  changeStatus,
  suppliertype,
  commissionRate,
  cancelReason,
  blockStatus,
  isError,
} = adminSlice.actions;

export default adminSlice.reducer;

export const getBodyStyle = () => {
  return async (dispatch) => {
    try {
      let token = localStorage.getItem("accessToken");
      let header = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      dispatch(changeStatus(STATUS.LOADING));
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/bodystyles`,
        header
      );
      let data = res.data.details;
      dispatch(bodyStyle(data));
      dispatch(changeStatus(STATUS.IDLE));
    } catch (error) {
      let err = error.response?.data?.message;
      dispatch(changeStatus(STATUS.ERROR));
      dispatch(isError(err));
    }
  };
};

export const getTransmission = () => {
  return async (dispatch) => {
    try {
      let token = localStorage.getItem("accessToken");
      let header = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      dispatch(changeStatus(STATUS.LOADING));
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/transmission`,
        header
      );
      let data = res.data.details;
      // console.log(data)
      dispatch(transmission(data));
      dispatch(changeStatus(STATUS.IDLE));
    } catch (error) {
      let err = error.response?.data?.message;
      dispatch(changeStatus(STATUS.ERROR));
      dispatch(isError(err));
    }
  };
};

export const getFuelType = () => {
  return async (dispatch) => {
    try {
      let token = localStorage.getItem("accessToken");
      let header = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      dispatch(changeStatus(STATUS.LOADING));
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/fueltype`,
        header
      );
      let data = res.data.details;
      dispatch(fuel_type(data));
      dispatch(changeStatus(STATUS.IDLE));
    } catch (error) {
      let err = error.response?.data?.message;
      dispatch(changeStatus(STATUS.ERROR));
      dispatch(isError(err));
    }
  };
};

export const getWarranty = () => {
  return async (dispatch) => {
    try {
      let token = localStorage.getItem("accessToken");
      let header = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      dispatch(changeStatus(STATUS.LOADING));
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/warranty`,
        header
      );
      let data = res.data.details;
      dispatch(warranty(data));
      dispatch(changeStatus(STATUS.IDLE));
    } catch (error) {
      let err = error.response.data.message;
      dispatch(changeStatus(STATUS.ERROR));
      dispatch(isError(err));
    }
  };
};
export const getDisputeTitle = () => {
  return async (dispatch) => {
    try {
      let token = localStorage.getItem("accessToken");
      let header = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      dispatch(changeStatus(STATUS.LOADING));
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/disputetitle`,
        header
      );
      let data = res.data.details;
      // console.log(res.data)
      dispatch(disputeTitle(data));
      dispatch(changeStatus(STATUS.IDLE));
    } catch (error) {
      let err = error.response?.data.message;
      dispatch(changeStatus(STATUS.ERROR));
      dispatch(isError(err));
    }
  };
};

export const getSuppliertype = () => {
  return async (dispatch) => {
    try {
      let token = localStorage.getItem("accessToken");
      let header = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      dispatch(changeStatus(STATUS.LOADING));
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/suppliertype`,
        header
      );
      let data = res.data.details;
      dispatch(suppliertype(data));
      dispatch(changeStatus(STATUS.IDLE));
    } catch (error) {
      let err = error.response?.data?.message;
      dispatch(changeStatus(STATUS.ERROR));
      dispatch(isError(err));
    }
  };
};
export const getCancelReason = () => {
  return async (dispatch) => {
    try {
      let token = localStorage.getItem("accessToken");
      let header = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      dispatch(changeStatus(STATUS.LOADING));
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/cancelreason`,
        header
      );
      let data = res.data.details;
      dispatch(cancelReason(data));
      dispatch(changeStatus(STATUS.IDLE));
    } catch (error) {
      let err = error.response?.data.message;
      dispatch(changeStatus(STATUS.ERROR));
      dispatch(isError(err));
    }
  };
};
export const deleteUserAPI = (user_id) => {
  return async (dispatch) => {
    try {
      let token = localStorage.getItem("accessToken");
      let header = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };

      dispatch(changeStatus(STATUS.LOADING));
      const res = await axios.delete(
        `${process.env.REACT_APP_SERVER_URL}/admin/deleteuser/${user_id}`,
        header
      );

      if (res.status === 200) {
        dispatch(deleteUserAPI());
        dispatch(changeStatus(STATUS.IDLE));
        // console.log("User deleted successfully");
      } else {
        dispatch(changeStatus(STATUS.ERROR));
        dispatch(isError("Failed to delete user"));
      }
    } catch (error) {
      dispatch(changeStatus(STATUS.ERROR));
      dispatch(isError(error.message));
    }
  };
};

export const getCommissionRate = () => {
  return async (dispatch) => {
    try {
      let token = localStorage.getItem("accessToken");
      let header = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };
      dispatch(changeStatus(STATUS.LOADING));
      let res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/commssionrate`,
        header
      );
      // console.log('API Commission:', res);
      let data = res.data.details;
      dispatch(commissionRate(data));
      dispatch(changeStatus(STATUS.IDLE));
    } catch (error) {
      let err = error.response?.data?.message;
      // console.log('Errorrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr:', err);
      dispatch(changeStatus(STATUS.ERROR));
      dispatch(isError(err));
    }
  };
};
export const blockOrUnblockUser = (id, currentStatus) => {
  return async (dispatch) => {
    try {
      const isBlocked =
        currentStatus === "BLOCKED_BY_ADMIN" ||
        currentStatus === "BLOCKED_BY_USER";
      const action = isBlocked ? "UNBLOCK" : "BLOCK";
      const token = localStorage.getItem("accessToken");
      const header = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      dispatch(changeStatus(STATUS.LOADING));

      await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/admin/block/${id}?action=${action}`,
        {},
        header
      );

      // Update redux state
      dispatch(
        blockStatus(action === "UNBLOCK" ? "ACTIVE" : "BLOCKED_BY_ADMIN")
      );

      dispatch(changeStatus(STATUS.IDLE));
    } catch (error) {
      dispatch(changeStatus(STATUS.ERROR));
      dispatch(
        isError(error.response?.data?.message || "Something went wrong")
      );
    }
  };
};
